import React from 'react';
import { DomeShowcase } from '../components/DomeShowcase';
import { Experience } from '../components/Experience';
import { FinalCTA } from '../components/FinalCTA';
import { PageIntro } from '../components/PageIntro';
import { RetreatSpaceDetails } from '../components/RetreatSpaceDetails';
import { UpcomingEvents } from '../components/UpcomingEvents';
import { WhatHappensHere } from '../components/WhatHappensHere';
export function RetreatSpacePage() {
  return <>
      <PageIntro eyebrow="Retreat Space" title="Host your next gathering." description="A unique venue for meaningful experiences — retreats, workshops, corporate days, yoga, breathwork and private events." data-id="element-747" data-mp="nxbjpxxcr5bc" />
      <DomeShowcase data-id="element-748" data-mp="xug8m5il1evu" />
      <Experience data-id="element-749" data-mp="xtwqoosxmqht" />
      <RetreatSpaceDetails data-id="element-750" data-mp="xtelv3s7f3ya" />
      <WhatHappensHere data-id="element-751" data-mp="a5nac2ehmuy2" />
      <UpcomingEvents data-id="element-752" data-mp="a4vc0jtiaj43" />
      <FinalCTA data-id="element-753" data-mp="a4c6k2l1ln6y" />
    </>;
}